import { Injectable } from '@angular/core';
import { DataInterceptorModel } from '../../domain/models/internal/data-interceptor.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataInterceptorService {
  colorPrimary:string="color:#7D5FFF";  
  colorRed:string = "color:red";
  line:string = "<--------------------------------------------------->"  
  baseUrl = environment.baseUrl;
  constructor() { }

  showData(data:DataInterceptorModel){
    console.log(`%c${this.line}`, this.colorPrimary); 
    console.log('Método:', data.Request.method)
    console.log('Servicio:',data.Request.url.slice(this.baseUrl.length + 1))
    if(data.Request.method != 'GET'){
       console.log('Request:', data.Request.body) 
    }
    console.log('Response:', data.Response.body);
  }

  showError(data:DataInterceptorModel){
    console.log(`%c${this.line}`, this.colorRed); 
    console.log('Método:', data.Request.method)
    console.log('Servicio:',data.Request.url.slice(this.baseUrl.length + 1))
    if(data.Request.method != 'GET'){
       console.log('Request:', data.Request.body) 
    }
    console.log('Error:', data.Error);
  }
}
